import { CircularProgress, Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import {
  DataTable,
  FilterSection,
  FilterStudent,
  SelectField,
  ToolbarComponent,
} from '../../../../../components'
// import { ImportIcon } from '../../../../../assets/icons'
import SchoolInfo from './PopOver/StudentPopUp'
import { studentHeadCells } from '../../../../../shared/data/headCells'
import { useGlobal } from '../../../../../shared'
import { baseURL, urls } from '../../../../../shared/config'
import { EditStudent } from './component/EditStudent'
import { StudentDetail } from './component/StudentDetail'
// import { setOpenImport } from '../../../../../redux/globalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { ImportIcon } from '../../../../../assets/icons'
import { setOpenImport } from '../../../../../redux/globalSlice'
import classes from './Student.module.css'
import DashboardCard from '../../Dashboard/component/Card'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import { useNavigate } from 'react-router-dom'
import IndividualStudent from './IndividualStudent/IndividualStudent'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
const Student = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [page, setPage] = useState(1)
  const [selectedGrade, setSelectedGrade] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const [selectedMonth, setSelectedMonth] = useState('')
  const navigate = useNavigate()
  // const [clear, setClear] = useState(false)

  // console.log('----customRole',customRole);

  const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [search, setSearch] = useState('')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const [schoolName, setSchoolName] = React.useState('')
  // console.log('-----schoolName', schoolName)
  const [feeStatus, setFeeStatus] = useState('')
  const [gradeValue, setGradeVal] = useState('')

  const {
    data: studentRow,
    count,
    loading,
    refetch,
  } = useGlobal({
    userUrl: `${urls.STUDENT_LIST}school_id=${customRole === 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&grade_id=${selectedGrade}&section_id=${selectedClass}&keyword=${search}`,
  })
  // console.log('----studentRow', studentRow)

  const dispatch = useDispatch()

  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=${page}&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // const { data: searchstudent, count: searchcount } = useGlobal({
  //   userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${selectedGrade}&fee_status=${feeStatus}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}`,
  // })

  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000`,
  })
  const individualStudent = useSelector((state) => state.global.openIndividualStudent)

  // console.log('---grades', grades)

  const [update, setUpdate] = useState(false)
  const [detail, setDetail] = useState(false)

  const rowData = studentRow

  const handleOpen = () => {
    // setSchoolInfo(true)
    navigate('/student-onboarding')
  }

  const no_data_msg =
    customRole == 'Admin'
      ? 'Add Student to start over'
      : schoolName
        ? 'Select school to see Students'
        : 'Select school to see Students'
  const pagecount = count
  const handleGradeChange = (event) => {
    const value = event.target.value
    setSelectedGrade(value)
    console.log('Selected grade:', value)
    // You can pass this value to parent or apply filter here
  }

  const handleClassChange = (event) => {
    const value = event.target.value
    setSelectedClass(value)
    console.log('Selected class:', value)
    // You can pass this value to parent or apply filter here
  }
  const handleMonthChange = (event) => {
    const value = event.target.value
    setSelectedMonth(value)
    console.log('Selected month:', value)
    // You can pass this value to parent or apply filter here
  }
  if (individualStudent) {
    return (
      <IndividualStudent
        userSchoolId={userSchoolId}
        customRole={customRole}
        setUpdate={setUpdate}
        setDetail={setDetail}
        detail={individualStudent}
        refetch={refetch}
      />
    )
  }
  if (update) {
    return (
      <IndividualStudent
        userSchoolId={userSchoolId}
        customRole={customRole}
        setUpdate={setUpdate}
        setDetail={setDetail}
        update={update}
        refetch={refetch}
      />
    )
  }
  if (detail) {
    return (
      <IndividualStudent
        userSchoolId={userSchoolId}
        customRole={customRole}
        setUpdate={setUpdate}
        setDetail={setDetail}
        detail={detail}
        refetch={refetch}
      />
    )
  }
  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with filters
      let filename = 'Students'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`
      }

      if (selectedGrade) {
        const grade = grades?.find((g) => g.grade_id === selectedGrade)
        filename += `_Grade_${grade?.grade || selectedGrade}`
      }

      if (selectedClass) {
        filename += `_Class_${selectedClass}`
      }

      // if (feeStatus) {
      //   filename += `_${feeStatus}`
      // }

      // Add date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      downloadCSV(rowData, filename)
    } else {
      alert('No data to export')
    }
  }
  // if (loading) {
  //   return (
  //     <div className="circular-box"  style={{
  //       height:'100dvh'
  //     }}>
  //       <CircularProgress />
  //     </div>
  //   )
  // }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Student'} subtitle={'Class / Students'} />
      {/* <div className={classes.analyticsContainer}>
        {analyticsData.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} />
        ))}
      </div> */}
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => setSchoolName(selectedOption)}
              setPage={setPage}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={handleOpen}
        search={search}
        setPage={setPage}
        setSearchItem={setSearch}
      >
        {/* <FilterStudent
          feeStatus={feeStatus}
          setFeeStatus={setFeeStatus}
          gradeValue={gradeValue}
          setGradeVal={setGradeVal}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
        /> */}
        <NewSelectedField
          student={true}
          selectedGrade={selectedGrade}
          selectedMonth={selectedMonth}
          selectedClass={selectedClass}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
          grades={grades}
          handleClassChange={handleClassChange}
          handleMonthChange={handleMonthChange}
          setSelectedClass={setSelectedClass}
          setSelectedGrade={setSelectedGrade}
          setSelectedMonth={setSelectedMonth}
        />

        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />

        {/* <FilterSection
          icon={ImportIcon}
          onClick={() => dispatch(setOpenImport(true))}
          title={'Import CSV'}
        /> */}
      </ToolbarComponent>
      {rowData?.length === 0 ? (
        <p>No student Found!</p>
      ) : (
        <DataTable
          headCells={studentHeadCells}
          rowData={rowData}
          student
          pages
          pageFee={page}
          noDataMsg={no_data_msg}
          setPageFee={setPage}
          school={false}
          search={search}
          setUpdate={setUpdate}
          pageCount={pagecount}
          // count={count}
          handleDetailOpen={() => setDetail(true)}
          refetch={refetch}
        />
      )}
      {openSchoolInfo && (
        <SchoolInfo
          customRole={customRole}
          userSchoolId={userSchoolId}
          open={openSchoolInfo}
          handleClose={() => setSchoolInfo(false)}
          title={'School Information'}
        />
      )}
      {/* {update && <EditStudent open={update} handleClose={() => setUpdate(false)} />} */}
      {/* {detail && <StudentDetail open={detail} handleClose={() => setDetail(false)} />} */}
    </div>
  )
}

export default Student
